module.exports = __webpack_public_path__ + "img/rejected.b4c02da8.png";